// extracted by mini-css-extract-plugin
export default {"comment__input":"Notice_comment__input__umpsQ","comment__input__field":"Notice_comment__input__field__Rrob7"};